import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=b3617eb8&scoped=true&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=b3617eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../translate-spring/user-center/person-center/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3617eb8",
  null
  
)

export default component.exports